import { createAsyncThunk } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import { httpRequest } from '~/adapters/httpRequest';
import { host } from '~/config/settings/worktango.settings';
import * as transformers from '../transformers';
import * as schemas from '../schemas';

const fetchAllLanguages = createAsyncThunk('language/fetchAllLanguages', async () => {
  const url = `${host}/languages`;
  const res = await httpRequest(url);

  const [languages, languageCodeIds] = transformers.languagesFrom(res?.payload?.languages);
  const normalizedData = normalize(languages, [schemas.language]);

  return {
    ...normalizedData,
    languageCodeIds,
  };
});

export const languageActions = {
  fetchAllLanguages,
};
